import { createFileRoute, notFound, stripSearchParams } from "@tanstack/react-router";
import { ApiError } from "@/api/client";
import { creatorPostsInfiniteQuery, creatorQuery } from "@/api/queries/creators";
import { meQuery } from "@/api/queries/me";
import { ProfilePage } from "@/pages/profile/ProfilePage";
import { ProfilePageSkeleton } from "@/pages/profile/ProfilePageSkeleton";

const TABS = ["posts", "products", "likes", "collections"] as const;
export type ProfileTab = (typeof TABS)[number];
export interface ProfileSearch { tab?: ProfileTab }

function validateSearch(search: Record<string, unknown>): ProfileSearch {
  const tab = typeof search.tab === "string" && TABS.includes(search.tab as ProfileTab)
    ? (search.tab as ProfileTab)
    : "posts";
  return { tab };
}

export const Route = createFileRoute("/_app/@{$username}")({
  validateSearch,
  search: { middlewares: [stripSearchParams<ProfileSearch>({ tab: "posts" })] },
  loader: async ({ context, params }) => {
    try {
      const creator = await context.queryClient.ensureQueryData(creatorQuery(params.username));
      await context.queryClient.ensureQueryData(meQuery());
      void context.queryClient.prefetchInfiniteQuery(creatorPostsInfiniteQuery(params.username));
      return creator;
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) throw notFound();
      throw error;
    }
  },
  pendingComponent: ProfilePageSkeleton,
  component: ProfilePage,
});
